import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IListOptions, IAPIListResponse, IRole, ICreateRoleInput, IRoleTemplate, IUpdateRoleInput } from '@newroom-connect/library/interfaces';

import { EntityService } from '../entity/entity.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends EntityService {
  public searchableProperties = ['name'];

  /**
   *
   * @param projectId
   * @param options
   *
   * @returns
   */
  public listRoles(projectId: string, options?: IListOptions): Observable<IAPIListResponse<IRole>> {
    return super.list<IRole>(`projects/${projectId}/roles`, undefined, options);
  }

  /**
   *
   * @param projectId
   * @param roleId
   *
   * @returns
   */
  public getRole(projectId: string, roleId: string): Observable<IRole> {
    return this.apiService.get<IRole>(`projects/${projectId}/roles/${roleId}`);
  }

  /**
   *
   * @param projectId
   * @param roleId
   *
   * @returns
   */
  public deleteRole(projectId: string, roleId: string): Observable<IRole> {
    return this.apiService.delete<IRole>(`projects/${projectId}/roles/${roleId}`);
  }

  /**
   * Update a role with new permissions and settings.
   *
   * @param projectId
   * @param roleId
   * @param role The role update data.
   *
   * @returns Observable of the updated role.
   */
  public updateRole(projectId: string, roleId: string, role: IUpdateRoleInput): Observable<IRole> {
    return this.apiService.patch<IRole>(`projects/${projectId}/roles/${roleId}`, role);
  }

  /**
   *
   * @param projectId
   * @param role
   *
   * @returns
   */
  public createRole(projectId: string, role: ICreateRoleInput): Observable<IRole> {
    return this.apiService.post<IRole>(`projects/${projectId}/roles`, role);
  }

  /**
   * Get all role templates with their permissions and conditions.
   *
   * @returns Observable of role templates array.
   */
  public getRoleTemplates(): Observable<IRoleTemplate[]> {
    return this.apiService.get<IRoleTemplate[]>('presets/roles/templates');
  }
}
